import {
  VscodeOption,
  VscodeSingleSelect,
} from "@vscode-elements/react-elements";
import { FC, useCallback } from "react";

import styles from "./SampleScannerPicker.module.css";

interface SampleScannerPickerProps {
  scanners: string[];
  selected: string;
  onChange: (scanner: string) => void;
}

function hasStringValue(target: EventTarget | null): target is EventTarget & {
  value: string;
} {
  return (
    target !== null && "value" in target && typeof target.value === "string"
  );
}

export const SampleScannerPicker: FC<SampleScannerPickerProps> = ({
  scanners,
  selected,
  onChange,
}) => {
  const handleChange = useCallback(
    (e: Event) => {
      if (hasStringValue(e.target)) {
        onChange(e.target.value);
      }
    },
    [onChange]
  );

  return (
    <div className={styles.picker}>
      <VscodeSingleSelect
        className={styles.select}
        aria-label="Select scanner"
        name="scanner"
        value={selected}
        onChange={handleChange}
      >
        {scanners.map((scanner) => (
          <VscodeOption key={scanner} value={scanner}>
            {scanner}
          </VscodeOption>
        ))}
      </VscodeSingleSelect>
    </div>
  );
};
